import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useStartInquiry } from "@/lib/useInquiry";
import PageTransition from "@/components/site/PageTransition";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import WorkPreview from "@/components/site/home/WorkPreview";
import AboutPreview from "@/components/site/home/AboutPreview";
import ServicesPreview from "@/components/site/home/ServicesPreview";
import CredibilityStrip from "@/components/site/home/CredibilityStrip";
import Reviews from "@/components/site/Reviews";
import GlobalPreview from "@/components/site/home/GlobalPreview";
import CtaBand from "@/components/site/home/CtaBand";

/**
 * HomePage — the cinematic gateway. Rather than carrying the whole site, the
 * home page is an art-directed introduction whose sections tease and route
 * into the dedicated pages (/work, /about, /services, /global, /contact).
 *
 * Order (per brief): Hero -> selected Work -> About preview -> selected
 * Services -> credibility -> selected Reviews -> Global preview -> strong CTA.
 */
export default function HomePage() {
    const navigate = useNavigate();
    const startInquiry = useStartInquiry();
    const viewWork = useCallback(() => navigate("/work"), [navigate]);

    return (
        <PageTransition>
            <div data-testid="home-page">
                <Hero onStartProject={startInquiry} onViewPortfolio={viewWork} />
                <Marquee />
                <WorkPreview />
                <AboutPreview />
                <ServicesPreview />
                <CredibilityStrip />
                <Reviews />
                <GlobalPreview />
                <CtaBand />
            </div>
        </PageTransition>
    );
}
